import axios from 'axios'

const sapConcur = {
  login (data) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_URL}/b2b-iam-app/authentication/login`,
      data
    })
  },

  create (data, token) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_URL}/b2b-sap-concur-app/linkAccount`,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: token
      },
      data
    })
  }
}

export default sapConcur
